import thinkingdata from "thinkingdata-browser";
import RE from "../assets/replace.js";

var config = {
    appId: "6954536dd5c2474faa75db576142dd54",
    serverUrl: "https://receiver.habby.fun/sync_js",
    showLog: false,
};

let publicData = {
    is_sandbox: RE.sandbox,
    game: RE.game,
    planid: RE.planid,
    cppid: RE.cppid,
    pid: RE.pid,
    c: RE.c,
    adset: RE.adset,
    ad: RE.ad,
};

thinkingdata.init(config);

export const TGA = {
    login(uniqueId) {
        thinkingdata.login(uniqueId);
    },
    // 上报
    track: function (event, data) {
        return new Promise((resolve, reject) => {
            thinkingdata.track(event, {...publicData, ...data});
            resolve();
        });
    },
};




// WEBPACK FOOTER //
// ./src/utils/tga.js